import React, { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "./components/loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./components/Common/PrivateRoute";
import UserDashboardLayout from "./components/layout/UserDashboardLayout";
import AgentDashboardMain from "./pages/AdminDashboard/AgentDashboardMain";
import AuditPropertyMain from "./pages/AdminDashboard/AuditPropertyMain";
const HomePage = lazy(() => import("./pages/HomePage"));
const HomeProperties = lazy(() => import("./pages/HomeProperties"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const About = lazy(() => import("./pages/About"));
const Featured = lazy(() => import("./pages/Featured"));
const Services = lazy(() => import("./pages/Services"));
const TermsConditions = lazy(() => import("./pages/TermsConditions"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const NotFound = lazy(() => import("./pages/NotFound"));
const MyCommissionSale = lazy(() =>
  import("./dashboard/agent-dashboard/my-commission-sale/my-commission-sale")
);
const MyCommissionAudit = lazy(() =>
  import("./dashboard/agent-dashboard/my-commission-audit/my-commission-rent")
);
const AgentDashboard = lazy(() =>
  import("./dashboard/agent-dashboard/AgentDashboard")
);
const AddAgent = lazy(() => import("./pages/AdminDashboard/AddAgent"));
const PropertyToBeAudited = lazy(() =>
  import("./dashboard/agent-dashboard/ViewAllPropertyToBeAudited")
);
const ViewAllPropertyScheduledForAudited = lazy(() =>
  import("./dashboard/agent-dashboard/ViewAllPropertyScheduledForAudited")
);
// const AddAgent = lazy(() => import("./dashboard/agent-dashboard/AddAgent"));
const UploadDocuments = lazy(() =>
  import("./dashboard/agent-dashboard/UploadDocuments")
);

const ComingSoon = lazy(() => import("./pages/ComingSoon"));
const Contact = lazy(() => import("./components/ContactUs"));
const FeaturedProp = lazy(() =>
  import("./components/featured-properties/Featured-properties")
);
const UploadPropertyImagesAndVideos = lazy(() =>
  import("./dashboard/agent-dashboard/post-property/UploadPropertyImages")
);
const RentProperty = lazy(() =>
  import("./dashboard/agent-dashboard/post-property/RentProperty")
);
const CommercialProperty = lazy(() =>
  import("./dashboard/agent-dashboard/post-property/commercialProperty")
);
const PropertyList = lazy(() =>
  import("./dashboard/Buy-property/PropertyList")
);
const PropertyView = lazy(() =>
  import("./dashboard/Buy-property/PropertyView")
);
const AgentPropertyView = lazy(() =>
  import("./dashboard/Buy-property/PropertyViewAgent")
);
const PostProperty = lazy(() => import("./pages/UserDashboard/PostProperty"));
const BuyProperty = lazy(() => import("./pages/UserDashboard/BuyProperty"));
const Wishlists = lazy(() => import("./pages/UserDashboard/Wishlists"));
const MyScheduleVisits = lazy(() =>
  import("./pages/UserDashboard/MyScheduleVisits")
);
const MyProperty = lazy(() => import("./pages/UserDashboard/MyProperty"));
const UserDashboard = lazy(() => import("./pages/UserDashboard/Dashboard"));
const PropertyScheduledForAudit = lazy(() =>
  import("./dashboard/agent-dashboard/Manage-Audit/PropertyScheduledForAudit")
);
const PropertyScheduledForVisit = lazy(() =>
  import("./dashboard/agent-dashboard/Manage-Audit/PropertyScheduledForVisit")
);
const PropertyBookededForVisit = lazy(() =>
  import("./dashboard/agent-dashboard/ViewAllPropertyBookedForVisit")
);
const PropertyScheduledForVisitList = lazy(() =>
  import("./dashboard/agent-dashboard/ViewAllPropertyScheduledForVisit")
);
const Settings = lazy(() =>
  import("./dashboard/agent-dashboard/settings/Settings")
);
const UserSettings = lazy(() =>
  import("./pages/UserDashboard/user-settings/UserSettings")
);
const AgentList = lazy(() => import("./dashboard/agent-dashboard/MyAgentList"));
const UpdateNewPassword = lazy(() => import("./pages/UpdateNewPassword"));
const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-us" element={<Navigate to="/about" replace />} />
        <Route path="/home-properties" element={<HomeProperties />} />
        <Route path="/featured" element={<Featured />} />
        <Route path="/services" element={<Services />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route
          path="/user-dashboard"
          element={<PrivateRoute Children={UserDashboard} />}
        />
        <Route
          path="/agent-dashboard"
          element={
            <PrivateRoute isAdminRoute={true} Children={AgentDashboardMain} />
          }
        />
        <Route
          path="/audit-property"
          element={
            <PrivateRoute isAdminRoute={true} Children={AuditPropertyMain} />
          }
        />
        <Route
          path="/agent-settings"
          element={<PrivateRoute isAdminRoute={true} Children={Settings} />}
        />
        
        <Route
          path="/add-agent"
          element={<PrivateRoute isAdminRoute={true} Children={AddAgent} />}
        />
        <Route
          path="/post-property"
          element={<PrivateRoute Children={PostProperty} />}
        />
        <Route
          path="/buy-property"
          element={<PrivateRoute Children={BuyProperty} />}
        />
         <Route
          path="/user-settings"
          element={<PrivateRoute  Children={UserSettings} />}
        />
        <Route
          path="/user-schedule-visit"
          element={<PrivateRoute Children={MyScheduleVisits} />}
        />
        <Route
          path="/wishlists"
          element={<PrivateRoute Children={Wishlists} />}
        />
        <Route
          path="/my-property"
          element={<PrivateRoute Children={MyProperty} />}
        />
        <Route
          path="/view-property/:propertyId"
          element={<PropertyView />}
        />
         <Route
          path="/view-property-agent/:propertyId"
          element={<PrivateRoute isAdminRoute={true} Children={AgentPropertyView} />}
        />
        <Route
          path="/property-view/:propertyId"
          element={<PropertyView />}
        />
        <Route
          path="/upload-image"
          element={<UploadPropertyImagesAndVideos />}
        />
        <Route
          path="/upload-image"
          element={<UploadPropertyImagesAndVideos />}
        />
        <Route path="/rent-property" element={<RentProperty />} />
        <Route path="/commercial-property" element={<CommercialProperty />} />
        <Route path="/property-list" element={<PropertyList />} />
        <Route path="/property-view" element={<PropertyView />} />
        <Route path="/property-view-agent" element={<AgentPropertyView />} />
        <Route path="/user" element={<PostProperty />} />
        <Route path="/agent" element={<AgentDashboard />} />
        <Route
          path="/property-to-be-audited"
          element={<PropertyToBeAudited />}
        />
        <Route
          path="/schedule-property-audited"
          element={<ViewAllPropertyScheduledForAudited />}
        />
        <Route path="/upload-documents" element={<UploadDocuments />} />
        <Route
          path="/manage-property-visit"
          element={<PrivateRoute isAdminRoute={true} Children={PropertyScheduledForVisit} />}
        />
        <Route
          path="/manage-property-audit"
          element={<PrivateRoute isAdminRoute={true} Children={PropertyScheduledForAudit} />}
        />
        <Route path="/book-visit" element={<PropertyBookededForVisit />} />
        <Route
          path="/scheduled-visit"
          element={<PropertyScheduledForVisitList />}
        />
        <Route path="/settings" element={<Settings />} />
        <Route path="/my-commission-sale" element={<PrivateRoute isAdminRoute={true} Children={MyCommissionSale} />} />
        <Route path="/my-commission-rent" element={<PrivateRoute isAdminRoute={true} Children={MyCommissionAudit} />} />
        <Route path="/my-agents-list" element={<PrivateRoute isAdminRoute={true} Children={AgentList} />} />
        <Route path="/update-new-password" element={<UpdateNewPassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
